
@if (!hidePopUp) {
  <div class="flex justify-between">
    <p class="font-bold text-xl leading-7" >Unlinked Financial Accounts</p>
    <button matTooltipPosition="above" data-dismiss="modal" class="bg-white" (click)="closeDialog()">
      <span class="material-icons relative bg-white text-[#898F9E] text-2xl">clear</span>
    </button>
  </div>
}
@if (!hidePopUp) {
  <div class="add-subfolder--container" style="height: 306px;overflow: auto;padding-right: 4px;">
    @if (!isLoadingData ) {
      <div   >
        @for (account of mxDatList; track account; let i = $index) {
          asdd
          dd
          <ng-container class="asset-list-group" style="margin-bottom: 12px;padding-bottom: 12px;">
            @if ((account | mxAccountList)>0) {
              <div >
                <mat-accordion>
                  <mat-expansion-panel
                    hideToggle
                    style="border-radius: 10px;"
                    class="border-panel"
                    [togglePosition]="'before'"
                    (mouseenter)="mouseEnterHandler($event, assetExpansionPanel)"
                    #assetExpansionPanel
                    [expanded]="account?.userAccounts.length > 0"
                    >
                    <!-- HEADER -->
                    <mat-expansion-panel-header style="
                    border-top:1px solid rgba(211, 220, 232, 0.7);
                    border-right:1px solid rgba(211, 220, 232, 0.7);
                    border-left:1px solid rgba(211, 220, 232, 0.7);
                    padding: 12px !important;
                    height: 66px !important;
                    border-radius: 10px 10px 0px 0px;"  class="estate-panel">
                      <mat-panel-title style="align-items: flex-start;">
                        <div   class="w-full "              >
                          <div class="flex justify-between" >
                            <div class="flex " >
                              <img  class="h-11 w-11 rounded" [src]="account?.institution?.small_logo_url" />
                              <div class="left-sub-div ml-2"  >
                                <div>
                                  <p style="margin-bottom: 4px !important;" class="m-0 font-bold text-[#010B18]  text-sm  leading-5"   >
                                    {{account?.name}}
                                    @if (+account?.userAccounts?.length > 0) {
                                      <span class="counter"  >
                                        &nbsp;({{account | mxAccountList}})
                                      </span>
                                    }
                                  </p>
                                  @if (+account?.userAccounts?.length > 0) {
                                    <p class="m-0 font-normal text-[#010B18] leading-4"  >
                                      {{account | mxAccountList}} Accounts
                                    </p>
                                  }
                                  @if (+account?.userAccounts?.length  == 0) {
                                    <p class="m-0 font-normal text-[#010B18] leading-4"  >
                                      No Accounts
                                    </p>
                                  }
                                </div>
                              </div>
                            </div>
                            <span class="material-icons open">arrow_right</span>
                            <span class="material-icons close">arrow_right</span>
                          </div>
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    @for (item of account?.userAccounts; track item) {
                      @if (!item?.vaultUserForm?.form_name) {
                        <p  (click)="createForm(item)" class="rounded-lg cursor-pointer font-semibold leading-7 p-1 mx-1"
                          style="border:1px solid rgba(211, 220, 232, 0.7);"
                          >
                          {{item?.name}}
                        </p>
                      }
                    }
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
            }
          </ng-container>
        }
      </div>
      @if (mxDatList.length == 0) {
        <div>
          <div class="flex-center zero-state">
            <img src="assets/images/no-filse-ingroup.svg" style="height: 90px;" />
            <p class="no-file-text">No accounts added yet</p>
          </div>
        </div>
      }
    } @else {
      <div class="loader-container flex w-full" style="flex-direction: column;">
        @for (item of loaderItems; track item) {
          <div >
            <div class="flex loader-body" style="width: 100%;" id="{{ item.id }}">
              <div class="ph-item width-100per loader-body-item">
                <div class="ph-col-12" style="padding: 0px !important;position: relative;top:-14px">
                  <div class="ph-row">
                    <div class="ph-col-12" style="height: 48px;padding:0px;margin: 0px;"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (Form1?.length) {
      <div
        style="height: 0px; width: 0px;visibility: hidden;">
        <template-basic-form
          [Form1]="Form1"
          [documentForm]="documentForm"
          >
        </template-basic-form>
      </div>
    }
  </div>
}
@if (!hidePopUp) {
  <div>
    <button
      (click)="createMxConnect()"
      style="padding: 0px !important; line-height: 38px !important;margin-bottom: 12px !important;"
      class=" app__btn--primary mt-0  h-[38px] "
      type="submit"
      >
      Add New
    </button>
  </div>
}

